import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.spadmin.details', {
        url: '/:cmpId',
        component: 'companySPAdminCompanyDetail',
        params: {cmp: {}},
        resolve: {cmp, cmpId, cmpDetail},
    });
}

/** @ngInject */
function cmpDetail(companyId, cmpId, $http) {
    const url = `app/rest/v2/company/${companyId}/saaspassadmin/company/${cmpId}`;
    return $http.get(url).then(({data}) => data)
    .then(cmpDetail => {
        return cmpDetail;
    })
}

/** @ngInject */
function cmpId($stateParams) {
    return $stateParams.cmpId;
}

/** @ngInject */
function cmp($stateParams) {
    return $stateParams.cmp;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/details/company-details.state.js